module.exports = {"apiUrl":"/api","COMMENT_FEATURE_ENABLE":true,"ENABLE_MULTIPLAYER_EDITING":true,"ENABLE_LOGS":false};